import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface EntitlementAndLicenseInfo {
    slEntitlement?: boolean;
    hlEntitlement?: boolean;
    licenseExists?: boolean;
    availableLicenses?: number;
}
interface BmcInfo {
    bmcInfo: EntitlementAndLicenseInfo | null;
}
const INITIAL_BMC_STATE: BmcInfo = {
    bmcInfo: null,
};
const BMC_SLICE = createSlice({
    name: "bmcStore",
    initialState: INITIAL_BMC_STATE,
    reducers: {
        setInfo(state, action: PayloadAction<EntitlementAndLicenseInfo>) {
            state.bmcInfo = action.payload;
        },
    },
});

export const { setInfo } = BMC_SLICE.actions;

export const bmcEolReducer = BMC_SLICE.reducer;
